import { Fn_activeAxios } from "function/FnConfig";

export type KdsConfigInfoRes = {
  alimTalk: {
    remainingPoint: number;
    sendable: boolean;
    alimTalkOrderChannelSettings: {
      kioskEnabled: boolean;
      posEnabled: boolean;
      qrOrderEnabled: boolean;
    };
  };
  usageInfo: {
    planName: 'BASIC_FARE' | 'ONLY_KDS_FARE' | 'PROMOTION_FARE' | 'MANAGER_FARE' | 'QR_KDS_FARE';
    availableOrderChannels: string[];
    enabledChannels: string[];
    unavailableOrderChannels: string[];
  };
};

export type KdsConfigInfoReq = {
	rootStore: any;
}


// kds 설정 정보 조회
export const getKdsConfigInfo = async (payload: KdsConfigInfoReq): Promise<KdsConfigInfoRes> => {
	const { searchStore } = payload.rootStore;
	const api = Fn_activeAxios(payload.rootStore);
	const response = await api.get(`/gate/kds/config/${searchStore.getShopCd}/${searchStore.getPosNo}/info`, {
	  headers: { "Content-Type": "application/json", Authorization: "Bearer " + searchStore.getToken },
	});
  
	return response.data;
  };
  